export default "__VITE_ASSET__DYHZrz4y__"